import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setDone(true);
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail) || "Failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <main data-testid="forgot-page" className="min-h-screen bg-black flex items-center justify-center px-6 pt-24 pb-12">
            <div className="w-full max-w-md">
                <Link to="/" className="font-serif text-3xl block mb-12">Tile<span className="text-gold">Sphere</span></Link>
                <div className="overline mb-3">Forgot Password</div>
                <h1 className="font-serif text-4xl mb-10 tracking-tight">Reset your access.</h1>
                {done ? (
                    <div className="border border-gold/40 p-6 text-sm text-white/80" data-testid="forgot-done">
                        If an account exists for <span className="text-gold">{email}</span>, a reset link has been generated. Check the backend logs for the demo token.
                    </div>
                ) : (
                    <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
                        <input required type="email" placeholder="Email" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full bg-[#0a0a0a] border border-white/15 px-4 py-4 focus:border-gold focus:outline-none" data-testid="forgot-email" />
                        <button disabled={busy} type="submit" className="btn-gold w-full" data-testid="forgot-submit">{busy ? "Sending…" : "Send reset link"}</button>
                    </form>
                )}
                <div className="mt-8 text-sm"><Link to="/login" className="text-white/60 hover:text-gold">← Back to sign in</Link></div>
            </div>
        </main>
    );
}
